// <PRODUCTS>
export const ANALYTICS_MONTHLY = "Analytics Monthly";
export const PREMIUM_DATABASE_ACCESS = "Premium Database Access";
// </PRODUCTS>

// <STEPS>
export const CHOOSE_A_PRODUCT = "Choose a Product";
export const CHOOSE_AN_INTEGRATION = "Choose an Integration";
export const REGISTER =  "Register";
export const CREATE_AN_ORGANIZATION = "Create an Organization";
export const TOS =    "TOS";
export const SET_UP_KEYS = "Set up Keys";
export const CHECKOUT =    "Checkout";


export const STEPS = [
    CHOOSE_A_PRODUCT,
    CHOOSE_AN_INTEGRATION,
    REGISTER,
    CREATE_AN_ORGANIZATION,
    TOS,
    SET_UP_KEYS,
    CHECKOUT
];
// </STEPS>